export default __webpack_public_path__ + "static/media/portis-logo.d30058b0.svg";